"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpdateCart = void 0;
var _graphql = require("../generated/graphql");
var _cart = require("../utils/cart");
var _useCart = require("./useCart");
var _router = require("next/router");
const useUpdateCart = (timeslot, slug, id, isolated) => {
  const cart = (0, _useCart.useCart)();
  const router = (0, _router.useRouter)();
  const buyTickets = async () => {
    if (!(0, _cart.getCartId)()) {
      return;
    }
    const url = isolated ? `/checkout/extras?isolated=true` : '/checkout/extras';
    await router.push(url);
  };
  const {
    setCart,
    removeOrderItem
  } = (0, _useCart.useSetCart)();
  const currentTickets = cart.cartQuery.data?.cart?.status === _graphql.CartStatusEnum.Open ? cart.tickets.filter(item => item.activity?.slug === slug) : [];
  return async newTicket => {
    let tickets = (0, _useCart.getTicketsInputFromCart)(cart?.cartQuery.data?.cart) ?? [];

    // don't use tickets from a stale cart
    if (cart.cartQuery.data?.cart?.status !== _graphql.CartStatusEnum.Open) {
      tickets = [];
    }
    if (!newTicket) {
      if (!timeslot) {
        return;
      }
      await removeOrderItem(timeslot.id, 'Ticket');
    } else {
      const isEditingTicket = currentTickets.some(ticket => ticket.activity?.id === id);
      if (isEditingTicket) {
        const currIndex = tickets.findIndex(cartTicket => cartTicket.timeslotId === newTicket?.timeslotId);
        tickets[currIndex] = newTicket;
      } else {
        tickets = tickets.concat(newTicket);
      }
      await setCart({
        tickets
      });
      await buyTickets();
    }
  };
};
exports.useUpdateCart = useUpdateCart;